/*
 * CIAO — accent dynamique basé sur la couleur sélectionnée.
 * Quand un produit a un sélecteur de couleur (swatch), la couleur choisie est
 * lue depuis le swatch déjà rendu par Dawn (--swatch--background / data-option-swatch-value)
 * puis exposée en variables CSS globales :
 *   --ciao-swatch-accent       (fond)
 *   --ciao-swatch-accent-text  (texte, calculé pour rester lisible)
 * La bannière d'annonce, le bouton "Ajouter au panier" et les pastilles de
 * taille consomment ces variables (voir sections/announcement-bar.liquid,
 * snippets/ciao-product-ux.liquid et sections/main-product.liquid).
 * N'a aucun effet sur les produits sans option de couleur (variables non définies).
 *
 * --ciao-swatch-accent-border : liseré visible uniquement quand la couleur
 * choisie est trop proche du blanc/fond de page (ex. variante "blanc"), pour
 * que le bouton plein ne se fonde pas dans l'arrière-plan.
 */
(function () {
  function parseSwatchColor(value) {
    if (!value) return null;
    value = value.trim();
    if (!value || value === 'unset' || value.indexOf('url(') === 0) return null;
    return value;
  }

  function relativeLuminance(rgbString) {
    var channels = rgbString.match(/[\d.]+/g);
    if (!channels || channels.length < 3) return null;
    var srgb = channels.slice(0, 3).map(function (channel) {
      var c = Number(channel) / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * srgb[0] + 0.7152 * srgb[1] + 0.0722 * srgb[2];
  }

  function applyAccent(rgbString) {
    var root = document.documentElement;
    if (!rgbString) {
      root.style.removeProperty('--ciao-swatch-accent');
      root.style.removeProperty('--ciao-swatch-accent-text');
      root.style.removeProperty('--ciao-swatch-accent-border');
      return;
    }
    root.style.setProperty('--ciao-swatch-accent', rgbString);
    var luminance = relativeLuminance(rgbString);
    var textColor = luminance !== null && luminance > 0.55 ? '#211F1B' : '#F5F1E9';
    root.style.setProperty('--ciao-swatch-accent-text', textColor);
    // Couleur quasi blanche : sans liseré, l'élément se fond dans le fond de page.
    var borderColor = luminance !== null && luminance > 0.9 ? 'rgba(33, 31, 27, 0.35)' : 'transparent';
    root.style.setProperty('--ciao-swatch-accent-border', borderColor);
  }

  function currentSwatchColor(main) {
    // On ne lit que le vrai sélecteur (variant-selects). La copie des
    // pastilles posée sous les photos par variant-media-row.js est ignorée.
    var checkedInput = main.querySelector('variant-selects .product-form__input--swatch input:checked');
    if (checkedInput) {
      var label = main.querySelector('label[for="' + checkedInput.id + '"] .swatch');
      var rgb = label && parseSwatchColor(label.style.getPropertyValue('--swatch--background'));
      if (rgb) return rgb;
    }

    var select = main.querySelector('variant-selects .product-form__input--dropdown select.select__select');
    if (select && select.selectedOptions.length) {
      var rgbFromOption = parseSwatchColor(select.selectedOptions[0].dataset.optionSwatchValue);
      if (rgbFromOption) return rgbFromOption;
    }

    return null;
  }

  function refresh(main) {
    applyAccent(currentSwatchColor(main));
  }

  function bind(main) {
    if (main.dataset.ciaoSwatchAccentBound) return;
    main.dataset.ciaoSwatchAccentBound = 'true';
    refresh(main);
    main.addEventListener('change', function (event) {
      if (!event.target.closest('.product-form__input--swatch, .product-form__input--dropdown')) return;
      refresh(main);
    });
  }

  function init() {
    document.querySelectorAll('[id^="MainProduct-"]').forEach(bind);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', init);
})();
